export const LOCATION_SEARCH_IS_FETCHING_SUGGESTIONS = 'LOCATION_SEARCH_IS_FETCHING_SUGGESTIONS';
export const LOCATION_SEARCH_SUGGESTIONS_FETCH_SUCCESS = 'LOCATION_SEARCH_SUGGESTIONS_FETCH_SUCCESS';
export const LOCATION_SEARCH_SUGGESTIONS_FETCH_FAILURE = 'LOCATION_SEARCH_SUGGESTIONS_FETCH_FAILURE';

export const LOCATION_SEARCH_IS_SELECTING_LOCATION = 'LOCATION_SEARCH_IS_SELECTING_LOCATION';
export const LOCATION_SEARCH_SELECT_LOCATION_SUCCESS = 'LOCATION_SEARCH_SELECT_LOCATION_SUCCESS';
export const LOCATION_SEARCH_SELECT_LOCATION_FAILURE = 'LOCATION_SEARCH_SELECT_LOCATION_FAILURE';
export const LOCATION_SEARCH_SELECT_LOCATION_COMPLETE = 'LOCATION_SEARCH_SELECT_LOCATION_COMPLETE';

export const LOCATION_SEARCH_RESET_LOCATION = 'LOCATION_SEARCH_RESET_LOCATION';



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/locationSearch/events.js